export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14253.a3a1608f.jpg";